import React from "react";
import { useSelector } from "react-redux";

interface DataPoint {
  totalBudget: number;
  totalCategories: number;
  totalDataElements: number;
  totalOrganizations?: number;
  usersCount: object;
  organizationAssignment: any; // Allows any structure for `organization`
  totalSubmissionDataCount: any;
  totalDataElementsCount: any;
  assignedDataElementsCount: any;
  totalRevenue: any;
  totalUsersCount: any;
}

const AdminDashboardDetails: React.FC<{ data: DataPoint }> = ({ data }) => {
  const user = useSelector((state: any) => state?.Auth);
  const userData = user?.user?.data || user?.user?.user;

  return (
    <div className="flex flex-wrap bg-[#10151A] rounded-[15px] mb-[20px] p-[10px]">
      {/* //Total organization fro admin and total categories for leader */}
      {[1, 2, 3].includes(userData?.roleId) && (
        <div
          className={
            [1, 2, 3].includes(userData?.roleId)
              ? "md:w-1/4 sm:w-2/4 w-full"
              : "md:w-1/3 sm:w-2/4 w-full"
          }
        >
          <div className="flex p-[15px] gap-[14px]  sm:border-1 sm:border-r sm:border-[#1E252D]">
            <div>
              <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full ">
                {[2, 3].includes(userData?.roleId) ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_299_7308)">
                      <path
                        d="M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
                        fill="#8B8B8B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_299_7308">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_299_7301)">
                      <path
                        d="M10 10.111V1L21 7V21H3V7L10 10.111ZM12 4.369V13.189L5 10.078V19H19V8.187L12 4.37V4.369Z"
                        fill="#8B8B8B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_299_7301">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </div>
            </div>
            <div>
              <h4 className="text-[12px] 2xl:text-sm mb-[5px]">
                {[2, 3].includes(userData?.roleId)
                  ? "Total Categories"
                  : "Total Organization"}
              </h4>
              <h6 className="text-[16px] 2xl:text-[18px]">
                {[2, 3].includes(userData?.roleId)
                  ? data?.totalCategories
                  : data?.totalOrganizations || "-"}
              </h6>
            </div>
          </div>
        </div>
      )}

      {/* Total Categories, assigned data elements , asssigned organization  */}
      <div
        className={
          [1, 2, 3].includes(userData?.roleId)
            ? "md:w-1/4 sm:w-2/4 w-full"
            : "md:w-1/3 sm:w-2/4 w-full"
        }
      >
        <div className="flex p-[15px] gap-[14px] sm:border-1 sm:border-r sm:border-[#1E252D]">
          <div>
            <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full ">
              {[2, 3].includes(userData?.roleId) ? (
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.375 2.625C18.6071 2.625 18.8296 2.71719 18.9937 2.88128C19.1578 3.04538 19.25 3.26794 19.25 3.5V17.5C19.25 17.7321 19.1578 17.9546 18.9937 18.1187C18.8296 18.2828 18.6071 18.375 18.375 18.375H2.625C2.39294 18.375 2.17038 18.2828 2.00628 18.1187C1.84219 17.9546 1.75 17.7321 1.75 17.5V3.5C1.75 3.26794 1.84219 3.04538 2.00628 2.88128C2.17038 2.71719 2.39294 2.625 2.625 2.625H18.375ZM17.5 14H3.5V16.625H17.5V14ZM7 4.375H3.5V12.25H7V4.375ZM12.25 4.375H8.75V12.25H12.25V4.375ZM17.5 4.375H14V12.25H17.5V4.375Z"
                    fill="white"
                    fillOpacity="0.5"
                  />
                </svg>
              ) : userData?.roleId === 1 ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_299_7308)">
                    <path
                      d="M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
                      fill="#8B8B8B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_299_7308">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_299_7301)">
                    <path
                      d="M10 10.111V1L21 7V21H3V7L10 10.111ZM12 4.369V13.189L5 10.078V19H19V8.187L12 4.37V4.369Z"
                      fill="#8B8B8B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_299_7301">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-[12px] 2xl:text-sm mb-[5px]">
              {[2, 3].includes(userData?.roleId)
                ? "Assigned Elements"
                : userData?.roleId === 1
                ? "Total Categories"
                : "Assigned Organizations"}
            </h4>
            <h6 className="text-[16px] 2xl:text-[18px]">
              {[2, 3].includes(userData?.roleId)
                ? data?.assignedDataElementsCount
                : userData?.roleId === 1
                ? data?.totalCategories
                : data?.organizationAssignment
                    ?.map((org: any) => org.organization?.shortCode)
                    .join(", ") || "-"}
            </h6>
          </div>
        </div>
      </div>

      {/* Our Budget , revenue, data submission  */}
      <div
        className={
          [1, 2, 3].includes(userData?.roleId)
            ? "md:w-1/4 sm:w-2/4 w-full"
            : "md:w-1/3 sm:w-2/4 w-full"
        }
      >
        <div className="flex p-[15px] gap-[14px]  sm:border-1 sm:border-r sm:border-[#1E252D]">
          <div>
            <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full ">
              {[1, 2, 3].includes(userData?.roleId) ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C17.523 2 22 6.477 22 12C22 14.4 21.154 16.604 19.744 18.328L19.778 18.364L18.364 19.778L18.328 19.744C16.5436 21.2062 14.307 22.0036 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM4 12C3.99998 13.4969 4.41995 14.9638 5.21217 16.2339C6.00438 17.5041 7.13706 18.5264 8.48143 19.1848C9.82579 19.8432 11.3279 20.1112 12.817 19.9583C14.3061 19.8054 15.7225 19.2378 16.905 18.32L14.53 15.944C14.3558 15.9814 14.1782 16.0002 14 16H13V18H11V16H8.5V14H14C14.1249 14.0002 14.2455 13.9537 14.3378 13.8695C14.4301 13.7853 14.4876 13.6696 14.4989 13.5452C14.5102 13.4207 14.4745 13.2966 14.3988 13.1972C14.3231 13.0977 14.2129 13.0303 14.09 13.008L14 13H10C9.56116 13 9.13006 12.8845 8.75002 12.665C8.36998 12.4456 8.0544 12.13 7.83498 11.75C7.61557 11.3699 7.50006 10.9388 7.50006 10.5C7.50007 10.0611 7.61558 9.63004 7.835 9.25L5.679 7.094C4.58778 8.49628 3.99678 10.2232 4 12ZM12 4C10.152 4 8.45 4.627 7.095 5.68L9.47 8.055C9.64422 8.01791 9.82188 7.99948 10 8H11V6H13V8H15.5V10H10C9.87505 9.99977 9.75455 10.0463 9.66222 10.1305C9.56988 10.2147 9.51241 10.3304 9.50112 10.4548C9.48983 10.5793 9.52554 10.7034 9.60122 10.8028C9.6769 10.9023 9.78705 10.9697 9.91 10.992L10 11H14C14.4388 11 14.8699 11.1155 15.25 11.335C15.63 11.5544 15.9456 11.87 16.165 12.25C16.3844 12.6301 16.4999 13.0612 16.4999 13.5C16.4999 13.9389 16.3844 14.37 16.165 14.75L18.321 16.905C19.2389 15.7224 19.8065 14.306 19.9593 12.8168C20.1121 11.3276 19.8441 9.82538 19.1856 8.48098C18.5271 7.13658 17.5046 6.00391 16.2343 5.21177C14.964 4.41963 13.497 3.99979 12 4Z"
                    fill="#8B8B8B"
                  />
                </svg>
              ) : (
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.375 2.625C18.6071 2.625 18.8296 2.71719 18.9937 2.88128C19.1578 3.04538 19.25 3.26794 19.25 3.5V17.5C19.25 17.7321 19.1578 17.9546 18.9937 18.1187C18.8296 18.2828 18.6071 18.375 18.375 18.375H2.625C2.39294 18.375 2.17038 18.2828 2.00628 18.1187C1.84219 17.9546 1.75 17.7321 1.75 17.5V3.5C1.75 3.26794 1.84219 3.04538 2.00628 2.88128C2.17038 2.71719 2.39294 2.625 2.625 2.625H18.375ZM17.5 14H3.5V16.625H17.5V14ZM7 4.375H3.5V12.25H7V4.375ZM12.25 4.375H8.75V12.25H12.25V4.375ZM17.5 4.375H14V12.25H17.5V4.375Z"
                    fill="white"
                    fillOpacity="0.5"
                  />
                </svg>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-[12px] 2xl:text-sm mb-[5px]">
              {[2, 3].includes(userData?.roleId)
                ? "Revenue"
                : userData?.roleId === 1
                ? "Our Budget"
                : "Data Submissions"}
            </h4>
            <h6 className="text-[16px] 2xl:text-[18px]">
              {[2, 3].includes(userData?.roleId)
                ? `$ ${data?.totalRevenue}`
                : userData?.roleId === 1
                ? `$  ${new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(data?.totalBudget ?? 0)}`
                : data?.totalSubmissionDataCount}
            </h6>
          </div>
        </div>
      </div>

      <div
        className={
          [1, 2, 3].includes(userData?.roleId)
            ? "md:w-1/4 sm:w-2/4 w-full"
            : "md:w-1/3 sm:w-2/4 w-full"
        }
      >
        <div className="flex p-[15px] gap-[14px]">
          <div>
            <div className="inline-flex items-center justify-center p-2 bg-primary rounded-full ">
              {[2, 3].includes(userData?.roleId) ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_299_7308)">
                    <path
                      d="M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
                      fill="#8B8B8B"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_299_7308">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.375 2.625C18.6071 2.625 18.8296 2.71719 18.9937 2.88128C19.1578 3.04538 19.25 3.26794 19.25 3.5V17.5C19.25 17.7321 19.1578 17.9546 18.9937 18.1187C18.8296 18.2828 18.6071 18.375 18.375 18.375H2.625C2.39294 18.375 2.17038 18.2828 2.00628 18.1187C1.84219 17.9546 1.75 17.7321 1.75 17.5V3.5C1.75 3.26794 1.84219 3.04538 2.00628 2.88128C2.17038 2.71719 2.39294 2.625 2.625 2.625H18.375ZM17.5 14H3.5V16.625H17.5V14ZM7 4.375H3.5V12.25H7V4.375ZM12.25 4.375H8.75V12.25H12.25V4.375ZM17.5 4.375H14V12.25H17.5V4.375Z"
                    fill="white"
                    fillOpacity="0.5"
                  />
                </svg>
              )}
            </div>
          </div>
          <div>
            <h4 className="text-[12px] 2xl:text-sm mb-[5px]">
              {[2, 3].includes(userData?.roleId)
                ? "Our Users"
                : userData?.roleId === 1
                ? "Total Data Elements"
                : "Assigned Data Elements"}
            </h4>
            <h6 className="text-[16px] 2xl:text-[18px]">
              {[2, 3].includes(userData?.roleId)
                ? data?.totalUsersCount
                : userData?.roleId === 1
                ? data?.totalDataElements
                : data?.totalDataElementsCount}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardDetails;
